module.exports = __webpack_public_path__ + "21a0c7e44a0ae0df42d47a59bdb6b28b.svg";